__turbopack_context__.v({
  "Button": "cookies-consent-dialog-view-module__78_MIG__Button",
});
